/**
 *
 * Publication archive in member page (JS)
 *
 * @author Space-Time Inc.
 *
 */

//'use strict';

document.addEventListener('DOMContentLoaded', () => {
	"use strict";

	const documentElement = document.documentElement;
	const scrollingElement = document.scrollingElement;

	const wrapperElement = document.getElementsByClassName('publication-wrapper')[0];
	if (wrapperElement === undefined) { return; }

	const buttonElement = document.getElementsByClassName('publication-toggle-button')[0];
	if (buttonElement === undefined) { return; }

	const checkboxElement = document.getElementsByClassName('publication-checkbox')[0];
	if (checkboxElement === undefined) { return; }

	const titleElement = document.getElementsByClassName('publication-title')[0];
	if (titleElement === undefined) { return; }

	//WordPress管理者用バー分のオフセット取得のため
	const wpadminbarElement = document.getElementById("wpadminbar");

	const wrapperHeight = wrapperElement.children[0].clientHeight;


	checkboxElement.addEventListener('change', () => {
		if (checkboxElement.checked) {
			buttonElement.classList.add('opened');
			wrapperElement.classList.add('opened');
			wrapperElement.style.maxHeight = wrapperElement.children[0].clientHeight + 'px';
			buttonElement.style.opacity = '0';
			setTimeout(function () {
				buttonElement.style.opacity = '';
				window.BackToTopLib.scrollFn();
				scrollFn();
			}, 1000);

		} else {
			buttonElement.classList.remove('opened');
			wrapperElement.classList.remove('opened');
			wrapperElement.style.maxHeight = '';
			buttonElement.style.opacity = '0';
			setTimeout(function () {
				buttonElement.style.opacity = '';
				window.BackToTopLib.scrollFn();
				scrollFn();
				let offsetByWpadminbar = wpadminbarElement ? parseFloat(wpadminbarElement.clientHeight) : 0;
				let toHeight = titleElement.getBoundingClientRect().top + window.pageYOffset - offsetByWpadminbar;
				scrollingElement.scrollTop = toHeight;
			}, 500);
		}
	});


	scrollFn();
	window.addEventListener("scroll", scrollFn);
	if ("ontouchstart" in window) {
		window.addEventListener("touchmove", scrollFn);
	}
	window.addEventListener("resize", scrollFn);


	function scrollFn() {
		let appearedHeight = wrapperElement.getBoundingClientRect().top + window.pageYOffset;

		if (wrapperElement.children[0].clientHeight < 1200) {
			buttonElement.style.display = 'none';
			wrapperElement.classList.add('opened');
		} else {
			buttonElement.style.display = 'block';
		}

		if (checkboxElement.checked && window.pageYOffset < appearedHeight) {
			buttonElement.classList.add("hidden");
		} else {
			buttonElement.classList.remove("hidden");
		}

		let viewBottomY;
		if (window.innerHeight > documentElement.clientHeight) {
			viewBottomY = scrollingElement.scrollTop + window.innerHeight;
		} else {
			viewBottomY = scrollingElement.scrollTop + documentElement.clientHeight;
		}
		let translateYValue = scrollingElement.scrollTop + wrapperElement.getBoundingClientRect().bottom + buttonElement.getBoundingClientRect().height + 18;
		if (checkboxElement.checked && viewBottomY < translateYValue) {

			resetStyleOfButtonElement();

			buttonElement.style.transform = 'translateY(-' + (translateYValue - viewBottomY) + 'px)';
			let cox = buttonElement.getBoundingClientRect().left;
			let cw = buttonElement.getBoundingClientRect().width;

			buttonElement.style.transform = "";
			buttonElement.style.position = 'fixed';
			buttonElement.style.bottom = 18 + 'px';
			buttonElement.style.left = cox + 'px';
			buttonElement.style.width = cw + 'px';
			buttonElement.style.margin = 'auto';

		} else {
			resetStyleOfButtonElement();
			buttonElement.style.transform = 'translateY(0px)';
		}
	};



	function resetStyleOfButtonElement() {
		buttonElement.style.position = 'relative';
		buttonElement.style.transform = "";
		buttonElement.style.bottom = '';
		buttonElement.style.left = '';
		buttonElement.style.width = '';
		buttonElement.style.margin = '';
	}

});
